import { MapPin, Mail, Clock, ArrowUpRight } from "lucide-react";
import { LogoMark } from "./LogoMark";
import { Reveal, Label } from "./Reveal";
import { FIRM } from "../../content";

const Block = ({ icon: Icon, title, children, id }) => (
  <div data-testid={id} className="border-t border-slate-300 py-7">
    <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.18em] text-slate-500">
      <Icon size={15} className="text-[#3B5B85]" /> {title}
    </div>
    <div className="mt-4 font-serif text-xl leading-relaxed text-[#0F2137]">{children}</div>
  </div>
);

export const Contact = ({ t }) => {
  const c = t.contact;
  const maps = (q) => "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(q);
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#F4F6F9] py-24 lg:py-36">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <Reveal><Label>{c.label}</Label></Reveal>
          <Reveal delay={0.1}><h2 className="mt-6 font-serif text-4xl leading-tight text-[#0F2137] md:text-5xl">{c.title}</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-6 text-base text-slate-600">{c.intro}</p></Reveal>
          <Reveal delay={0.2}>
            <div data-testid="contact-registration-card" className="mt-12 flex items-center gap-6 border border-slate-300 bg-white p-6">
              <LogoMark className="h-20 w-20 shrink-0" />
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.18em] text-slate-500">{c.regTitle}</p>
                <p className="mt-2 font-serif text-xl text-[#0F2137]">{FIRM.name}</p>
                <p className="text-sm text-slate-600">N° {FIRM.reg} · Grande Comore</p>
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-8 lg:col-start-5">
          <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.18em] text-slate-500">
            <MapPin size={15} className="text-[#3B5B85]" /> {c.address}
          </div>
          <div className="mt-5 grid sm:grid-cols-3 sm:gap-x-8" data-testid="contact-address-block">
            {FIRM.offices.map((o) => (
              <div key={o.id} data-testid={`office-${o.id}`} className="border-t border-slate-300 py-7">
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#3B5B85]">{o.head ? c.head : c.branch}</p>
                <p className="mt-2 font-serif text-2xl font-semibold text-[#0F2137]">{o.island}</p>
                <div className="mt-3 font-serif text-lg leading-relaxed text-[#0F2137]">
                  {o.lines.map((l) => <span key={l} className="block">{l}</span>)}
                </div>
                <a data-testid={`office-map-link-${o.id}`} href={maps(o.q)} target="_blank" rel="noreferrer" className="nav-link mt-3 inline-flex items-center gap-1 text-sm text-[#3B5B85]">
                  {c.map} <ArrowUpRight size={14} />
                </a>
              </div>
            ))}
          </div>
          <div className="mt-6 grid sm:grid-cols-2 sm:gap-x-10">            <Block icon={Clock} title={c.hours} id="contact-hours-block">
              {c.hoursV.map((l) => <span key={l} className="block text-lg">{l}</span>)}
            </Block>
            <Block icon={Mail} title={c.email} id="contact-email-block">
              <a data-testid="contact-email-link" href={`mailto:${FIRM.email}`} className="nav-link break-all">{FIRM.email}</a>
            </Block>
          </div>
        </div>
      </div>
    </section>
  );
};
